import React from 'react';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export function UserReportLayout() {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  return (
    <FDStack direction="column" spacing={1} flex={1} width="100%">
      <MetaControlField attr="userDescription" fullWidth />
      <MetaLayoutRemainingFields />
      <FDStack direction="row" justifyContent="flex-end">
        {resource.meta().canSubmit() && (
        <FDPrimaryActionButton
          onClick={onSubmit}
          label="Submit"
          loading={saving}
        />
        )}
      </FDStack>
    </FDStack>
  );
}
